angular.module('leanlaw').controller('ReadyToBillCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  var _accounting;
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const {
      hideZero,
      include
    } = $scope.filter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      if (hideZero && !c.data.amounts.total) {
        return accum;
      }
      let item = {};
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            [matter]: "",
            "Ready to Bill Hours": $filter("amount")(c.data.amounts.hours),
            "Expenses": $filter("amount")(c.data.amounts.expenses),
            "Fixed Fees": $filter("amount")(c.data.amounts.charges),
            "Total": $filter("amount")(c.data.amounts.total),
            "Receivables Balance": c.data.accounting ? $filter("amount")(c.data.accounting.balance) : '',
            "Last Payment": c.data.accounting && c.data.accounting.lastPayment ? $filter("amount")(c.data.accounting.lastPayment.amount) : '',
            "Last Payment Date": c.data.accounting && c.data.accounting.lastPayment && c.data.accounting.lastPayment.date ? $filter("dateLogical")(c.data.accounting.lastPayment.date) : '',
            "Trust Balance": c.data.accounting ? $filter("amount")(c.data.accounting.trustBalance) : ''
          };
        } else {
          item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            "Ready to Bill Hours": $filter("amount")(c.data.amounts.hours),
            "Expenses": $filter("amount")(c.data.amounts.expenses),
            "Fixed Fees": $filter("amount")(c.data.amounts.charges),
            "Total": $filter("amount")(c.data.amounts.total),
            "Receivables Balance": c.data.accounting ? $filter("amount")(c.data.accounting.balance) : '',
            "Last Payment": c.data.accounting && c.data.accounting.lastPayment ? $filter("amount")(c.data.accounting.lastPayment.amount) : '',
            "Last Payment Date": c.data.accounting && c.data.accounting.lastPayment && c.data.accounting.lastPayment.date ? $filter("dateLogical")(c.data.accounting.lastPayment.date) : '',
            "Trust Balance": c.data.accounting ? $filter("amount")(c.data.accounting.trustBalance) : ''
          };
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        item = {
          "Client": c.client.name,
          [matter]: "",
          "Ready to Bill Hours": $filter("amount")(c.data.amounts.hours),
          "Expenses": $filter("amount")(c.data.amounts.expenses),
          "Fixed Fees": $filter("amount")(c.data.amounts.charges),
          "Total": $filter("amount")(c.data.amounts.total),
          "Receivables Balance": c.data.accounting ? $filter("amount")(c.data.accounting.balance) : '',
          "Last Payment": c.data.accounting && c.data.accounting.lastPayment ? $filter("amount")(c.data.accounting.lastPayment.amount) : '',
          "Last Payment Date": c.data.accounting && c.data.accounting.lastPayment && c.data.accounting.lastPayment.date ? $filter("dateLogical")(c.data.accounting.lastPayment.date) : '',
          "Trust Balance": c.data.accounting ? $filter("amount")(c.data.accounting.trustBalance) : ''
        };
      } else {
        item = {
          "Client": c.client.name,
          "Ready to Bill Hours": $filter("amount")(c.data.amounts.hours),
          "Expenses": $filter("amount")(c.data.amounts.expenses),
          "Fixed Fees": $filter("amount")(c.data.amounts.charges),
          "Total": $filter("amount")(c.data.amounts.total),
          "Receivables Balance": c.data.accounting ? $filter("amount")(c.data.accounting.balance) : '',
          "Last Payment": c.data.accounting && c.data.accounting.lastPayment ? $filter("amount")(c.data.accounting.lastPayment.amount) : '',
          "Last Payment Date": c.data.accounting && c.data.accounting.lastPayment && c.data.accounting.lastPayment.date ? $filter("dateLogical")(c.data.accounting.lastPayment.date) : '',
          "Trust Balance": c.data.accounting ? $filter("amount")(c.data.accounting.trustBalance) : ''
        };
      }
      if ($scope.evergreen) {
        item["Evergreen"] = c.data.accounting.evergreen;
      }
      accum.push(item);
      if (include && include.matters) {
        c.matters.forEach(m => {
          if (hideZero && !m.data.amounts.total) {
            return;
          }
          const item = {
            "ID": m.matter.reference ? !isNaN(m.matter.reference) ? `="${m.matter.reference}"` : m.matter.reference : '',
            "Client": "",
            [matter]: m.matter.name,
            "Ready to Bill Hours": $filter("amount")(m.data.amounts.hours),
            "Expenses": $filter("amount")(m.data.amounts.expenses),
            "Fixed Fees": $filter("amount")(m.data.amounts.charges),
            "Total": $filter("amount")(m.data.amounts.total),
            "Receivables Balance": m.data.accounting ? $filter("amount")(m.data.accounting.balance) : '',
            "Last Payment": m.data.accounting && m.data.accounting.lastPayment ? $filter("amount")(m.data.accounting.lastPayment.amount) : '',
            "Last Payment Date": m.data.accounting && m.data.accounting.lastPayment && m.data.accounting.lastPayment.date ? $filter("dateLogical")(m.data.accounting.lastPayment.date) : '',
            "Trust Balance": m.data.accounting ? $filter("amount")(m.data.accounting.trustBalance) : ''
          };
          if ($scope.evergreen && m.data.accounting) {
            item["Evergreen"] = m.data.accounting.evergreen;
          }
          accum.push(item);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  userService.me().then(me => {
    $scope.accounting = me.company.integration.quickbooks;
    $scope.trust = me.company.settings.trustEnabled;
    $scope.evergreen = $scope.trust && me.company.settings.trust.evergreen;
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.distributionId = undefined;
      if ($scope.filter.filter.range) {
        loadAmounts();
        // Only load balances if the scope has changes (balances are not affected by other changes such as time range)
        if ($scope.accounting) {
          loadBalances();
        }
      }
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  });
  function loadAmounts() {
    $scope.loading = true;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'clients';
    query.reportType = 'productivity';
    query.billingType = '-internal';
    query.data = "services,expenses,charges,lastpayment";
    query.zeros = false;
    query.billed = "false";
    query.billedState = undefined;
    query.reportType = 'wip';
    query.chargeCompleted = true;
    return singleRequest.apiCall("ready-to-bill-amounts", true).getReport(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      $scope.clientReferences = data.clients.some(c => c.client.reference);
      $scope.loading = false;
      mergeAccounting();
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  function loadBalances() {
    $scope.loadingBalances = true;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'clients';
    query.billingType = '-internal';
    query.data = "receivables,lastpayment";
    query.zeros = false;
    query.chargeCompleted = true;
    query.reportType = 'wip';
    if ($scope.trust) {
      query.data += ",trust";
    }
    _accounting = null;
    return singleRequest.apiCall("ready-to-bill-balances", true).getReport(query).then(data => {
      if (!data) return;
      _accounting = data;
      $scope.loadingBalances = false;
      mergeAccounting();
    }).catch(err => {
      $scope.loadingBalances = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("ready-to-bill-amounts");
    singleRequest.cancel("ready-to-bill-balances");
    deactivate();
  });
  function mergeAccounting() {
    // This merges the trust and receivables balances into the main object
    // (they are loaded separately because the trust/receivables can be slow due to the fact that it interfaces with QBO)
    if ($scope.loadingBalances || $scope.loading || !_accounting || !$scope.data) return;
    _accounting.clients.forEach(client => {
      let targetClient = $scope.data.clients.find(c => c.client.id == client.client.id);
      if (!targetClient) {
        targetClient = {
          client: angular.copy(client.client),
          data: {
            hours: {},
            amounts: {}
          },
          matters: []
        };
        $scope.data.clients.push(targetClient);
      }
      targetClient.data.accounting = angular.copy(client.data.accounting);
      targetClient.data.accounting.onlyTrust = !targetClient.data.amounts.total && !targetClient.data.accounting.balance;
      client.matters.forEach(matter => {
        let targetMatter = targetClient.matters.find(m => m.matter.id == matter.matter.id);
        if (!targetMatter) {
          targetMatter = {
            matter: angular.copy(matter.matter),
            data: {
              hours: {},
              amounts: {}
            }
          };
          targetClient.matters.push(targetMatter);
        }
        targetMatter.data.accounting = angular.copy(matter.data.accounting);
        targetMatter.data.accounting.onlyTrust = !targetMatter.data.amounts.total && !targetMatter.data.accounting.balance;
      });
    });
  }

  // MatterId may be optional
  $scope.goToSummary = function (clientId, matterId) {
    $state.go("reports.client-summary", {
      clientId,
      matterId,
      return: "reports.ready-to-bill",
      report: `Ready to Bill`
    });
  };
}]);